export const requestCancelledTradesQuery = () => `
    query privateCancelledTrades($fromDate: DateTime!, $toDate: DateTime!) {
        privateCancelledTrades(fromDate: $fromDate, toDate: $toDate) {
            trading_gateway
            comp_id
            order_id
            symbol
            side
            price
            quantity
            trade_id
            counterparty
            timestamp
            cancelled
            cancelled_at
            replaced_at
            orders {
                status
                trader_id
                record_keeping {
                    client_id
                    client_type
                }
            }
        }
    }
`;

export const requestBrokenTradeReportsQuery = () => `
    query privateBrokenTradeReports($fromDate: DateTime!, $toDate: DateTime!) {
        privateBrokenTradeReports(fromDate: $fromDate, toDate: $toDate) {
            geniuminetTradeReports {
            trading_gateway
            comp_id
            id
            trade_report_id
            trade_report_ref_id
            status
            is_initiated
            is_internal
            trader_id
            symbol
            side
            price
            quantity
            settlement_date
            trade_publish_indicator
            trade_registration_timestamp
            capacity
            trade_type
            trade_id
            match_id
            deal_id
            counterparty
            counterparty_capacity
            last_updated
            last_updated_by
            reject_reason
            }
            inetTradeReports {
            id
            trading_gateway
            status
            reason
            is_initiated
            symbol
            price
            quantity
            settlement_date
            timestamp
            trade_type
            trade_registration_timestamp
            trade_publish_indicator
            trade_clearing_instruction
            execution_method
            side
            capacity
            is_internal
            trade_id
            counterparty
            counterparty_capacity
            executing_firm
            trader_id
            }
        }
    }
`;

export const requestAlertsSummaryQuery = () => `
query GetAlertsSummary ($fromDate: DateTime!, $toDate: DateTime!) {
    alertsSummary (
        fromDate: $fromDate,
        toDate: $toDate
    ) {
        id
        description
        latest_alert
        count_alerts
        status_count {
            forreview
            open
            watch
            investig
            critical
            explained
            closed
        }
    }
}
`;

export const requestAlertsSummaryPerTraderIdQuery = () => `
query GetAlertsSummaryPerTraderId ($fromDate: DateTime!, $toDate: DateTime!) {
    alertsSummaryByTraderId (
        fromDate: $fromDate,
        toDate: $toDate
    ) {
        status_count {
            forreview
            open
            watch
            investig
            critical
            explained
            closed
        }
        description
        id
        trader_id
        count_alerts
    }
}
`;

export const requestAlertsSummaryPerClientIdQuery = () => `
query GetAlertsSummaryPerTraderId ($fromDate: DateTime!, $toDate: DateTime!) {
    alertsSummaryByClientId (
        fromDate: $fromDate,
        toDate: $toDate
    ) {
        status_count {
            forreview
            open
            watch
            investig
            critical
            explained
            closed
        }
        description
        id
        private_client_id
        count_alerts
    }
}
`;

export const requestPublicTradesForGroupQuerry = () => `
    query publicTradesForGroup($day: String!, $symbol: String!) {
        publicTradesForGroup(day: $day, symbol: $symbol) {
            symbol
            trade_date
            timestamp
            side
            price
            volume
            trade_class
            trade_type
            trade_cancel
            update_code
            trade_buyer
            trade_seller
            order_id
            trade_number
        }
    }
`

export const requestPublicOrdersByLevelQuerry = () => `
    query publicOrdersByLevel($day: String!, $symbol: String!) {
        publicOrdersByLevel(day: $day, symbol: $symbol) {
            id
            symbol
            trade_date
            update_code
            price
            yield
            quantity
            number_of_orders
            level
            side
            dirty_price
            price_per_point
            duration
            time_exec_utc
            time_exec
            updated
            inserted
        }
    }
    `